import { Component } from '@angular/core';

import { Observable, of } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MenuService, RenderableMenu } from '@layout-lib';
import { BrandComponent } from '../../../layout/brand/brand.component';
import { MenusComponent } from '../../../layout/menus/menus.component';

@Component({
  selector: 'era-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  imports: [FaIconComponent, BrandComponent, MenusComponent, RouterOutlet, AsyncPipe],
})
export class DefaultComponent {
  public readonly menus$: Observable<RenderableMenu[]>;

  public collapsed = true;
  constructor(menuService: MenuService) {
    this.menus$ = of(menuService.menu);
  }
}
